// extracted by mini-css-extract-plugin
export const main = "news-module--main--oK6sW";
export const contents = "news-module--contents--1ccqi";
export const content = "news-module--content--1oqWv";
export const pagination = "news-module--pagination--3NCYR";
export const selected = "news-module--selected--31_QQ";